import delegate from "delegate-it";
import ajax from "@/scripts/common/ajax";
import { scrollToIfNeeded } from "@/scripts/common/scroll-to";
import { updateQueryParams } from "@/scripts/common/util";

const form = document.querySelector(".filter-form");

const updateResults = async () => {
  const pageContent = document.querySelector("[data-page-content]");

  const loadingTimeout = setTimeout(() => {
    pageContent.classList.add("is-loading");
  }, 300);

  const res = await ajax.get(window.location.href).json();

  clearTimeout(loadingTimeout);

  pageContent.innerHTML = res.page;
  pageContent.classList.remove("is-loading");

  if (res.isFiltered) {
    scrollToIfNeeded(pageContent, 24);
  }
};

const handleFilter = (e) => {
  const url = updateQueryParams([[e.target.name, e.target.value]]);

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleFilterClear = (e) => {
  e.preventDefault();

  const url = updateQueryParams(false);
  window.history.replaceState({}, "", url);

  updateResults();
};

const handleSolutionChange = (e) => {
  const detail = e.detail;

  let solutionParam = false;

  if (detail.key !== "") {
    solutionParam = detail.key;
  }

  const url = updateQueryParams([["solution", solutionParam]]);

  window.history.replaceState({}, "", url);

  updateResults();
};

document.addEventListener("DOMContentLoaded", () => {
  if (form) {
    delegate(".filter-form", "change", handleFilter);
    delegate(".filter-form", "form:clear", handleFilterClear);
  }

  delegate("html", "solution:change", handleSolutionChange);
});
